(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-slideshow"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  if (typeof Swiper === 'undefined') {
    console.error('Swiper is not loaded. Include Swiper JS in theme.liquid.');
    return;
  }

  const slider = document.querySelector('.custom-slideshow.swiper');
  if (!slider) return;

  const autoplayEnabled = slider.dataset.autoplay === 'true';
  const autoplayDelay = parseInt(slider.dataset.speed) || 5000;

  new Swiper(slider, {
    loop: true,
    slidesPerView: 1,
    spaceBetween: 0,
    pagination: {
      el: slider.querySelector('.swiper-pagination'),
      clickable: true
    },
    navigation: {
      nextEl: slider.querySelector('.swiper-button-next'),
      prevEl: slider.querySelector('.swiper-button-prev')
    },
    autoplay: autoplayEnabled
      ? { delay: autoplayDelay, disableOnInteraction: false }
      : false,
    speed: 800,
    effect: 'slide'
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-with-image"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  const faqContainers = document.querySelectorAll('.faq-section__accordion');
  
  faqContainers.forEach(container => {
    const items = container.querySelectorAll('.faq-item');
    items.forEach(item => {
      const button = item.querySelector('.faq-question');
      button.addEventListener('click', () => {
        // Close all
        items.forEach(i => i.classList.remove('active'));
        // Open clicked one
        if (!item.classList.contains('active')) {
          item.classList.add('active');
        }
      });
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial-slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", () => {
  const initTestimonialSlider = () => {
    const sliderEl = document.querySelector(".testimonial-slider__wrapper");

    if (!sliderEl || typeof Swiper === "undefined") return;

    // Destroy existing instance if any
    if (sliderEl.swiper) {
      sliderEl.swiper.destroy(true, true);
    }

    new Swiper(sliderEl, {
      slidesPerView: 1,
      spaceBetween: 24,
      grabCursor: true,
      watchOverflow: false,
      loop: false,
      pagination: {
        el: ".testimonial-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        640: { slidesPerView: 1.2 },
        768: { slidesPerView: 2 },
        1024: { slidesPerView: 3 },
      },
      on: {
        init: function () {
          // Unlock arrows if enough slides
          this.navigation.update();
        },
      },
    });
  };

  // Initialize when DOM is ready
  initTestimonialSlider();

  // Reinitialize when Shopify theme editor loads or resizes
  document.addEventListener("shopify:section:load", initTestimonialSlider);
  document.addEventListener("shopify:section:reorder", initTestimonialSlider);
  window.addEventListener("resize", () => {
    setTimeout(initTestimonialSlider, 300);
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["variant-grid"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", () => {
  // === Add to Cart ===
  const buttons = document.querySelectorAll(".add-to-cart-btn");
  buttons.forEach((btn) => {
    btn.addEventListener("click", async () => {
      const variantId = btn.dataset.variantId;
      btn.textContent = "Adding...";
      btn.disabled = true;

      try {
        const res = await fetch(window.Shopify.routes.root + "cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: variantId, quantity: 1 }),
        });

        if (res.ok) {
          const cartRes = await fetch(window.Shopify.routes.root + "cart.js");
          const cartData = await cartRes.json();

          document.dispatchEvent(new CustomEvent("cart:updated", { detail: { cart: cartData } }));
          document.dispatchEvent(new CustomEvent("cart:refresh", { detail: { cart: cartData } }));

          const cartCountEls = document.querySelectorAll("[data-cart-count], .cart-count, .header__cart-count");
          cartCountEls.forEach((el) => {
            el.textContent = cartData.item_count || 0;
          });

          const cartToggle = document.querySelector("[data-drawer='cart'], [data-open-drawer='cart']");
          if (cartToggle) cartToggle.click();

          btn.textContent = "Added!";
          setTimeout(() => {
            btn.textContent = "Add to Cart";
            btn.disabled = false;
          }, 1500);
        } else {
          btn.textContent = "Error";
        }
      } catch (err) {
        console.error("Cart add error:", err);
        btn.textContent = "Error";
      }
    });
  });

  // === Swiper with breakpoints ===
  const grid = document.querySelector(".variant-grid.swiper");
  if (grid && typeof Swiper !== "undefined") {
    new Swiper(grid, {
      slidesPerView: 1,
      spaceBetween: 16,
      speed: 600,
      pagination: {
        el: grid.querySelector(".swiper-pagination"),
        clickable: true,
      },
      navigation: {
        nextEl: grid.querySelector(".swiper-button-next"),
        prevEl: grid.querySelector(".swiper-button-prev"),
      },
      breakpoints: {
        769: { slidesPerView: 2, spaceBetween: 24 },  // tablet
        1025: { slidesPerView: 3, spaceBetween: 30 }, // desktop
      },
    });
  } else {
    console.error("Swiper is not loaded or .variant-grid not found.");
  }
});

  } catch(e) { console.error(e); }
})();
})();
